import { render, staticRenderFns } from "./CategoryFeed.vue?vue&type=template&id=16d1efff&scoped=true&"
import script from "./CategoryFeed.vue?vue&type=script&lang=js&"
export * from "./CategoryFeed.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFeed.vue?vue&type=style&index=0&id=16d1efff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1efff",
  null
  
)

export default component.exports